const commissionDetailsReportFilters = {
  userId: null,
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  businessEntityId: null
}

export default () => Object.assign({}, commissionDetailsReportFilters)
